import { Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsDateString,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  MaxLength,
  Min,
  MinLength,
  ValidateNested,
} from 'class-validator';

export class AnnotationDto {
  @IsUUID('4')
  id!: string;

  @IsString()
  @MaxLength(500)
  quotedText!: string;

  @IsString()
  @MinLength(1)
  @MaxLength(2000)
  comment!: string;

  @IsDateString()
  createdAt!: string;
}

export class AiQuestionDto {
  @IsUUID('4')
  id!: string;

  @IsString()
  @MinLength(1)
  @MaxLength(500)
  quotedText!: string;

  @IsString()
  @MinLength(1)
  @MaxLength(2000)
  question!: string;

  @IsDateString()
  createdAt!: string;
}

export class UpdateSectionDto {
  @IsString()
  @IsNotEmpty()
  @MaxLength(50000)
  contentHtml!: string;

  @IsInt()
  @Min(1)
  version!: number;

  @IsOptional()
  @IsArray()
  @ArrayMaxSize(20)
  @ValidateNested({ each: true })
  @Type(() => AnnotationDto)
  annotations?: AnnotationDto[];

  @IsOptional()
  @IsArray()
  @ArrayMaxSize(15)
  @ValidateNested({ each: true })
  @Type(() => AiQuestionDto)
  aiQuestions?: AiQuestionDto[];
}
